export default {
    active: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, sets the item active.',
        },
    },
    disabled: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, sets the item disabled.',
        },
    },
    icon: {
        type: String,
        docs: {
            validation: 'Must be a valid icon name.',
            description: 'Sets the left icon.',
        },
    },
    iconRight: {
        type: String,
        docs: {
            validation: 'Must be a valid icon name.',
            description: 'Sets the right icon.',
        },
    },
    text: {
        type: String,
        docs: {
            validation: '**Required**',
            description: 'Sets the item text.',
        },
    },
};
